import { getPhoneIdentityKey } from "./phone";

export const FREE_CONTACT_VISIBILITY_LIMIT = 50;
export const FREE_APPROVED_VISIBILITY_LIMIT = FREE_CONTACT_VISIBILITY_LIMIT;

const uniqueContacts = contacts => {
  const seen = new Set();
  return contacts.filter((contact, index) => {
    const key = getPhoneIdentityKey(contact?.phoneNumber) || `missing-phone:${index}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const getFreeContactsVisibility = (event = {}, contactsValue = event.contacts) => {
  const contacts = Array.isArray(contactsValue) ? contactsValue : [];
  const isFree = event.rsvpAccess?.classification === "FREE";
  const unique = isFree ? uniqueContacts(contacts) : contacts;
  return {
    isFree,
    contactCount: unique.length,
    isLimited: isFree && unique.length > FREE_CONTACT_VISIBILITY_LIMIT,
    visibleContacts: isFree ? unique.slice(0, FREE_CONTACT_VISIBILITY_LIMIT) : contacts,
  };
};

// Interface restriction only; contact persistence and owner permissions are unchanged.
export const isFreeContactDeletionLocked = (event = {}, contacts = event.contacts) => {
  const visibility = getFreeContactsVisibility(event, contacts);
  return visibility.isFree && visibility.contactCount >= FREE_CONTACT_VISIBILITY_LIMIT;
};
export const FREE_DELETION_MESSAGE = "במסלול החינמי לא ניתן למחוק אנשי קשר כאשר יש 50 אנשי קשר ומעלה. ניתן לשדרג לאישורי הגעה ללא הגבלה.";
export const getFreeRsvpVisibility = (event = {}, contacts = []) => {
  const visibility = getFreeContactsVisibility(event, contacts);
  return { ...visibility, approvedCount: visibility.visibleContacts.filter(contact => contact?.status === "approved").length };
};
export const visiblePhoneKeys = contacts => new Set(contacts.map(contact => getPhoneIdentityKey(contact?.phoneNumber)).filter(Boolean));
export const isVisiblePhone = (keys, phone) => keys.has(getPhoneIdentityKey(phone));
